<template>
  <v-row
    :dense="dense"
    @click="url ? $router.push({ path: url }) : null"
    :class="{ 'cursor-pointer': url }"
  >
    <v-col cols="auto" class="my-auto pl-10">
      <v-avatar class="border--bordercolor">
        <v-icon v-if="coreCountsIcon" size="25" color="secondary">
          $vuetify.icons.core_counts
        </v-icon>
        <v-icon v-else-if="icon" color="secondary">{{ icon }}</v-icon>
        <v-img v-else :src="image" max-width="25" contain></v-img>
      </v-avatar>
    </v-col>
    <v-col>
      <v-card-title>
        {{ title }}
        <slot name="titleExtension"></slot>
      </v-card-title>
      <v-card-subtitle>
        {{ subtitle }}
      </v-card-subtitle>
      <slot></slot>
      <div :class="`ml-4 ${helpTextColor}--text pb-4`" v-if="$slots.helpText">
        <slot name="helpText"> </slot>
      </div>
    </v-col>
    <v-spacer class="limited-spacer"> </v-spacer>
    <v-col cols="auto" class="my-auto pr-10">
      <v-badge overlap color="transparent" :value="pulsingDot">
        <template v-slot:badge>
          <div class="pulsing-dot"></div>
        </template>
        <v-avatar
          :color="complete ? 'accent' : 'background'"
          v-if="!$slots.action"
        >
          <v-icon :color="complete ? 'white' : null">
            {{ actionIcon || (complete ? "check" : "chevron_right") }}
          </v-icon>
        </v-avatar>
      </v-badge>
      <slot name="action"></slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FeatureListItem",
  props: {
    url: { type: String },
    icon: { type: String },
    coreCountsIcon: { type: Boolean, default: false },
    image: { type: String },
    title: { type: String },
    subtitle: { type: String },
    complete: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    pulsingDot: { type: Boolean, default: false },
    actionIcon: { type: String },
    helpTextColor: { type: String, default: "accent" }
  },
  components: {},
  data: () => ({}),
  watch: {},
  computed: {},
  created() {},
  methods: {}
};
</script>
